import { Dialog } from '@mui/material';

import { FC, useState } from 'react';
import {
  ArrayField,
  BooleanField,
  Button,
  Datagrid,
  FieldProps,
  Labeled,
  List,
  Show,
  SimpleShowLayout,
  TextField,
  useRecordContext,
  useShowController,
} from 'react-admin';
import styles from './styles.module.scss';

export const InsalesShow: FC = () => {
  const data = useShowController();
  const {
    record: { id } = {},
    // isLoading,
    // isFetching,
  } = data;

  //   const handleClickEdit = useCallback(() => {
  //     navigate(`/insales/${id}`);
  //   }, [id, navigate]);

  //   if (isLoading || isFetching) {
  //     return <Loading />;
  //   }
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(-1);
  const [selectedProductId, setSelectedProductId] = useState(-1);

  const updateDialogState = (id: number, pr_id: number) => {
    setSelectedId(id);
    setSelectedProductId(pr_id);
    setOpen(true);
  };

  const MyButtonField = (props: any) => {
    const record = useRecordContext(); // Get the current record data
    // const id = record[source]; // Access the ID of the product

    const handleRowClick = (pr_id: any) => {
      // Your logic here
      console.log(id, pr_id); // Log the id and user to console
      updateDialogState(id, pr_id);
    };
    return (
      <Button label={props.label} onClick={() => handleRowClick(record.id)} />
    );
  };

  const StrippedTextField = (props: FieldProps) => {
    const value = useRecordContext(props);
    if (props.source !== undefined) {
      const sources = props.source.split('.');
      let desc = '';
      if (sources.length === 1) {
        desc = value[sources[0]];
      } else {
        desc = value[sources[0]][sources[1]];
      }
      var stripedHtml = desc.replace(/<[^>]+>/g, '');
      return <span>{stripedHtml}</span>;
    }
    return <span></span>;
  };

  const filter = { id: id };
  return (
    <>
      <Show>
        <SimpleShowLayout>
          <Labeled label="Title">
            <TextField source="name" />
          </Labeled>
          <Labeled label="URL">
            <TextField source="url" />
          </Labeled>
          <Labeled label="API пользователь">
            <TextField source="user" />
          </Labeled>
          <Labeled label="API пароль">
            <TextField source="password" />
          </Labeled>
          <Labeled label="Включено ли обновление?">
            <BooleanField source="is_enabled" />
          </Labeled>
          <Labeled label="URL сайта">
            <TextField source="site_url" />
          </Labeled>
          <Labeled label="Список товаров" className={styles.InsalesShow}>
            <List
              emptyWhileLoading
              resource="insales_products"
              filter={filter}
              exporter={false}
            >
              <Datagrid className={styles.InsalesShow}>
                <TextField source="id" />
                <TextField source="title" label="Название" />
                <StrippedTextField
                  source="short_description"
                  label="Короткое описание"
                />
                <TextField source="variants[0].price" label="Цена" />

                <MyButtonField source="id" label="Детали" />
                {/* <Button onClick={() => handleRowClick(id)}>Details</Button> */}
              </Datagrid>
            </List>

            {/* <Modal open={open} onClose={() => setOpen(false)} title="Список товаров" size="middle">
            <Show resource='insales_products'>
                <TextField source="id"/>
            </Show>
        </Modal> */}
          </Labeled>
        </SimpleShowLayout>
      </Show>

      <Dialog open={open} onClose={() => setOpen(false)} title="Список товаров">
        <Show
          resource="insales_products"
          id={selectedId}
          queryOptions={{ meta: { product_id: selectedProductId } }}
        >
          <div className={styles.DialogInsales}>
            <SimpleShowLayout>
              <Labeled label="Title">
                <TextField source="product.title" label="Название" />
              </Labeled>
              <Labeled label="Короткое описание">
                <StrippedTextField source="product.short_description" />
              </Labeled>
              <Labeled label="Описание">
                <StrippedTextField source="product.description" />
              </Labeled>
              <Labeled label="Вопросы и ответы">
                <StrippedTextField source="product.faq" />
              </Labeled>
              <Labeled label="Цена">
                <TextField source="product.variants[0].price" label="Цена" />
              </Labeled>
              <Labeled label="Остаток">
                <TextField
                  source="product.variants[0].quantity"
                  label="Остаток"
                />
              </Labeled>
              <Labeled label="Характеристики" className={styles.InsalesShow}>
                <ArrayField source="product.properties">
                  <Datagrid bulkActionButtons={false}>
                    <TextField source="title" />
                    <TextField source="value" />
                  </Datagrid>
                </ArrayField>
              </Labeled>
            </SimpleShowLayout>
          </div>
        </Show>
      </Dialog>
    </>
  );
};
